export default "__VITE_ASSET__vSm75zay__"